import { getAuthHeaders } from "../common/helpers";
import { resolveApiUrl } from "./apiUrl";

export interface FaqItem {
  id: number;
  question: string;
  answer: string;
  isActive: boolean;
  orderIndex: number;
}

export async function fetchActiveFaqs(): Promise<FaqItem[]> {
  // Env files carry this either absolute or relative to avatar-core; a relative value must
  // never reach fetch() directly or it resolves against the SPA's own origin.
  const url = resolveApiUrl(process.env.REACT_APP_FAQ_ACTIVE_PATH);
  if (!url) {
    throw new Error("Missing REACT_APP_FAQ_ACTIVE_PATH");
  }

  const response = await fetch(url, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      ...getAuthHeaders(),
    },
  });

  if (!response.ok) {
    throw new Error(`FAQ API error: ${response.statusText}`);
  }

  const body = await response.json();
  return Array.isArray(body) ? body : (body?.data ?? []);
}
